export default "__VITE_ASSET__Dl06VtFG__"